<template>
  <table class="searcher-results w3-table search">
    <thead>
      <tr>
        <th v-if="(header.id !== idColumn && header.id !== codeColumn && header.id !== externalUrlColumn) || showId"
          v-for="header in searcherHeader" :key="header.id"
          :class="{'boolean' : getType(header.id) === 'boolean'}"
        >
          <searcher-header
            :header="header"
            @refreshHeaderOrder="refreshHeaderOrder"
          />
        </th>
        <th
          v-if="idColumn !== '' || externalUrlColumn !== ''"
        >
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(row, index) in rows">
        <tr
          :class="['resultat_taula', {'detailOpened' : isDetailOpened(row.requestIdValue)}]"
          @click="resultSelected(row.requestIdValue)"
          :key="`row-${index}`"
        >
          <td
            v-for="column in row.requestIdValue" :key="column.id"
            v-if="(column.id !== idColumn && column.id !== codeColumn && column.id !== externalUrlColumn) || showId"
          >
            <span v-if="getType(column.id) === 'boolean'" class="boolean"><i :class="getBooleanIconValue(column.value)"></i></span>
            <span v-else-if="getType(column.id) === 'image'" class="image">
              <img v-if="column.value && column.value !== ''" :src="column.value" />
            </span>
            <span v-else-if="getType(column.id) === 'url' && column.value !== ''"><a class="urlLink" :href="column.value" target="_blank">{{ column.value }} <i class="fas fa-external-link-alt"></i></a></span>
            <span v-else>{{ column.value }}</span>
          </td>
          <td
            v-if="idColumn !== '' || externalUrlColumn !== ''"
            v-tooltip="{content: $ml.get('id').toUpperCase() + ': ' + getColumnIdValue(row.requestIdValue), delay: { show: 400, hide: 100 }}"
            :class="['id']"
          >
            <i class="fa fa-angle-right"></i>
          </td>
        </tr>
        <tr
          v-if="detailInRow && rowDetails[getColumnIdValue(row.requestIdValue)].open"
          class="resultat_taula_detail"
          :key="`row-detail-${index}`"
        >
          <td
            v-for="column in row.requestIdValue" :key="column.id"
            v-if="column.id === idColumn"
            :colspan="getDetailColspan(row.requestIdValue)"
          >
            <transition name="fade" mode="out-in">
              <div v-show="rowDetails[column.value].open" :class="['row_detail_content', column.value]">
                <transition name="fade" mode="out-in">
                  <definition-loader v-if="rowDetails[column.value].loaderProps"
                    v-bind="rowDetails[column.value].loaderProps"
                    :searcherDetailDefinition="true"
                    @formDataActionCalled="formDataActionCalled"
                  />
                  <spinner-loading v-else class="spinner-loading" size="25" />
                </transition>
              </div>
            </transition>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import SearcherHeader from '@/components/content/searcher/header'
import transport from 'vue-definition-utils/src/utils/transport'
import * as api from '@/utils/api'
import DefinitionLoader from '@/components/content/definitionLoader'

export default {
  name: 'searcher-table',
  props: [
    'idColumn',
    'codeColumn',
    'externalUrlColumn',
    'searcherHeader',
    'rows',
    'detailInRow',
    'detailInRowType',
    'showId',
    'contentId'
  ],
  data () {
    return {
      rowDetails: {
      }
    }
  },
  components: {
    SearcherHeader,
    DefinitionLoader
  },
  beforeMount () {
    // init rowDetail
    for (var j = 0; j < this.rows.length; j++) {
      var columns = this.rows[j].requestIdValue
      // this.$set for binding new object
      this.$set(this.rowDetails, this.getColumnIdValue(columns), {open: false, loaderProps: null})
    }
  },
  methods: {
    resultSelected (columns, event) {
      if (!this.detailInRow) {
        this.$emit('resultSelected', columns)
      } else {
        var id = this.getColumnIdValue(columns)
        this.rowDetails[id].open = !this.rowDetails[id].open
        if (!this.rowDetails[id].loaderProps) {
          api.call({access: api.ACCESS_SERVICES, url: this.detailInRowType.endpoint, method: 'POST', data: { id: this.contentId, code: id }})
            .then(resp => {
              var loaderProps = {
                content: resp
              }
              loaderProps.content.endpoint = this.detailInRowType.endpoint
              loaderProps.content.id = this.detailInRowType.content.id
              loaderProps.id = this.detailInRowType.content.id
              loaderProps.name = this.detailInRowType.content.name
              loaderProps.type = this.detailInRowType
              loaderProps.saveDefinition = false
              loaderProps.saveDefinitionTo = null

              this.rowDetails[id].loaderProps = loaderProps
            })
            .catch(err => {
              console.error(err)
            })
        }
      }
    },
    getColumnIdValue (columns) {
      var result = ''
      if (this.externalUrlColumn !== '') {
        result = transport.methods.getSearcherColumnValue(columns, this.externalUrlColumn)
      } else if (this.idColumn !== '') {
        result = transport.methods.getSearcherColumnValue(columns, this.idColumn)
      }
      return result
    },
    refreshHeaderOrder (id, order) {
      this.$emit('refreshHeaderOrder', id, order)
    },
    isDetailOpened (columns) {
      var result = false
      var rowDetail = this.rowDetails[this.getColumnIdValue(columns)]
      if (rowDetail) {
        result = rowDetail.open
      }
      return result
    },
    getDetailColspan (columns) {
      var result = columns.length
      if (this.showId) {
        result += 1
      }
      return result
    },
    formDataActionCalled (stay) {
      this.$emit('refreshDefinitionContent')
    },
    getBooleanIconValue (value) {
      var result

      result = ''

      if (value === '1' || value === 'true' || value === 'si' || value === 'active') {
        result += 'fa fa-check'
      } else if (value === '0' || value === 'false' || value === 'no' || value === 'inactive') {
        result += 'fa fa-times'
      } else {
        result += ''
      }

      return result
    },
    getType (id) {
      var result

      result = null
      for (var i = 0; i < this.searcherHeader.length && !result; i++) {
        if (this.searcherHeader[i].id === id) {
          result = this.searcherHeader[i].type
        }
      }

      return result
    }
  }
}
</script>

<style lang="scss">
table.searcher-results {
  background-color: #fff;
  border-collapse:separate;
  border-spacing: 0 6px;

  th {
    font-family: Barlow;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #554b5a;
    text-align: left;
    padding: 5px 20px 5px 8px !important;

    &.boolean {
      span {
        display: block;
        width: 100%;
        text-align: center;
      }
      .order-sort {
        width: 100%;
        text-align: center;
        margin-left: 0;
      }
    }
  }

  tr.resultat_taula {
    background-color: #f8f8f8;
    transition: background-color 0.2s;
    transition-timing-function: cubic-bezier(.16,1.03,.41,.82);
  }

  td {
    font-family: Barlow;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.11;
    letter-spacing: normal;
    line-break: anywhere;
    color: #342d38;
    padding: 8px 20px 8px 8px !important;
    vertical-align: middle;
    transition: color 0.2s;
    transition-timing-function: cubic-bezier(.16,1.03,.41,.82);

    span.boolean {
      display: block;
      width: 100%;
      text-align: center;

      .fa-times {
        color: #f87474;
      }

      .fa-check {
        color: #2dd32d;
      }
    }

    span.image {
      img {
        max-width: 250px;
        border-radius: 5px;
      }
    }
  }
}

.detailLoader {
  table.searcher-results {
    tr.resultat_taula {
      td.id {
        text-align: right;
        font-size: 18px;

        i {
          transition: all 0.2s;
        }
      }

      .urlLink {
        text-decoration: none;
        color: #56becb;

        i {
          font-size: 12px;
          margin-left: 5px;
        }

        &:hover {
          text-decoration: underline;
        }
      }

      &.detailOpened {
        td {
          &.id {
            color: #ffbd42;

            i {
              transform: rotate(90deg);
            }
          }
        }
      }
    }

    tr.resultat_taula:hover {
      background-color: #DBEBEE;
      cursor: pointer;
    }

    tr.resultat_taula:hover td {
      color: #5698A2;

      &.id {
        color: #ffbd42;
      }
    }

    tr.resultat_taula_detail > td {
      padding: 0;

      .definition-title {
        display: none;
      }

      .multiselect__content-wrapper {
          position: relative;
      }
    }

    .row_detail_content {
      background-color: #fff;
      padding: 0 15px;
      border-left: 1px solid #e4e4e4;

      .groupTasks {
        float: none;
        padding: 0;

        .searcher-filters {
          display: none;
        }

        .contenidor_taula {
          margin: 0;
          min-height: auto;

          .loadingResults {
            min-height: auto !important;
          }

          td:first-child,
          td:last-child {
            border: 0;
          }
        }

        .searcher-results {
          border: 0;
        }

        #paginador {
          border: 0;

          .pages {
            background-color: transparent;
            margin-top: 0;
            padding: 3px 3px 2px;

            .movePage.disabled {
              background-color: transparent !important;
            }

            .results {
              display: none;
            }
          }
        }
      }

      #type_actions {
        position: relative !important;
        background-color: transparent !important;
        height: 50px !important;
        z-index: 1 !important;

        .buttons {
          margin-top: 0;
          width: 60%;

          button {
            width: auto;
            min-width: auto;
            height: 40px !important;
            background-color: #d7d7d7 !important;

            &.update-and-stay,
            &.save-and-stay {
              display: none;
            }

            span {
              font-size: 14px !important;
              color: #342d38 !important;
            }
          }
        }

        .messages {
          margin-top: 0;
          width: 40%;

          .formErrors,
          .formSaved {
            margin-left: 0;
            font-size: 1em !important;
          }
        }
      }

      .definition-wrapper {
        &.group {
          background-color: #fff !important;
          padding: 0 !important;
        }
      }

      .list-complete-item {
        max-height: 100px;

        .buttons {
          display: none;
        }

        .complete-item {
          padding: 0 10px 0;
        }
      }
    }
  }
}

.detail-wrapper {
  table.searcher-results {
    border-left: 1px solid #e4e4e4;
    border-right: 1px solid #e4e4e4;
  }

  td:first-child {
    border-left: 1px solid #e4e4e4;
  }

  td:last-child {
    border-right: 1px solid #e4e4e4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/searcher/table.vue